import { Box, useTheme } from "@mui/material";
import { ResponsiveLine } from "@nivo/line";

const ConsumptionLineChart = ({ memoizedData }) => {
    const theme = useTheme();

    return (
        <Box
            gridColumn="span 4"
            gridRow="span 2"
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginTop={-1}
            sx={{
                backgroundColor: theme.palette.background.alt,
                borderRadius: "2.5rem",
                padding: "1rem",
                height: "100%",
            }}
        >
            <Box width="100%" height="100%">
                {memoizedData.length > 0 ? (
                    <ResponsiveLine
                        data={[
                            {
                                id: "Consommation",
                                data: memoizedData
                                    .slice(0, 5) // Get top 5 entries
                                    .map((item) => ({
                                        x: item.waterBillRefNumber,
                                        y: item.consommation,
                                    })),
                            },
                        ]}
                        margin={{ top: 20, right: 20, bottom: 80, left: 70 }}
                        xScale={{ type: "point" }}
                        yScale={{
                            type: "linear",
                            min: 0,
                            stacked: false,
                            reverse: false,
                        }}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                            orient: "bottom",
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 90,
                            legend: "Réf. Facture Eau",
                            legendOffset: 60,
                            legendPosition: "middle",
                        }}
                        axisLeft={{
                            orient: "left",
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legend: "Total Consommation",
                            legendOffset: -50,
                            legendPosition: "middle",
                        }}
                        enableGridX={false}
                        enableGridY={false}
                        pointSize={10}
                        pointBorderWidth={2}
                        pointLabelYOffset={-12}
                        useMesh={true}
                        legends={[
                            {
                                anchor: "middle",
                                direction: "column",
                                justify: false,
                                translateX: 50,
                                translateY: 0,
                                itemsSpacing: 0,
                                itemDirection: "left-to-right",
                                itemWidth: 80,
                                itemHeight: 20,
                                itemOpacity: 0.75,
                                symbolSize: 12,
                                symbolShape: "circle",
                                symbolBorderColor: "rgba(0, 0, 0, .5)",
                                effects: [
                                    {
                                        on: "hover",
                                        style: {
                                            itemBackground: "rgba(0, 0, 0, .03)",
                                            itemOpacity: 1,
                                        },
                                    },
                                ],
                            },
                        ]}
                        theme={{
                            axis: {
                                domain: {
                                    line: {
                                        stroke: theme.palette.secondary[200],
                                    },
                                },
                                legend: {
                                    text: {
                                        fill: theme.palette.secondary[200],
                                    },
                                },
                                ticks: {
                                    line: {
                                        stroke: theme.palette.secondary[200],
                                        strokeWidth: 1,
                                    },
                                    text: {
                                        fill: theme.palette.secondary[200],
                                    },
                                },
                            },
                            grid: {
                                line: {
                                    stroke: theme.palette.grey[200],
                                },
                            },
                            legends: {
                                text: {
                                    fill: theme.palette.secondary[200],
                                },
                            },
                            tooltip: {
                                container: {
                                    background: theme.palette.background.paper,
                                    color: theme.palette.text.primary,
                                },
                            },
                        }}
                    />
                ) : (
                    <>Pas de données disponibles.</>
                )}
            </Box>
        </Box>
    );
};

export default ConsumptionLineChart;